import moment from 'moment'

export const getCookie = (a) => {
  var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)')
  return b ? b.pop() : ''
}

export const setCookie = (cname, cvalue, exdays) => {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export const queryStringToObject = (string) => {
  return JSON.parse('{"' + decodeURI(string).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

//Usage: importAll(require.context('images/brands/', false, /\.(png|jpe?g|svg)$/))
export const importAll = (r) => {
  let images = {}
  r.keys().map((item) => {
    images[item.replace('./', '')] = r(item)
  })
  return images
}

export const nl2br = (str, isXhtml) => {
  // discuss at: http://locutus.io/php/nl2br/
  // original by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Philip Peterson
  // improved by: Onno Marsman (https://twitter.com/onnomarsman)
  // improved by: Atli Þór
  // improved by: Brett Zamir (http://brett-zamir.me)
  // improved by: Maximusya
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  // bugfixed by: Kevin van Zonneveld (http://kvz.io)
  // bugfixed by: Reynier de la Rosa (http://scriptinside.blogspot.com.es/)
  // input by: Brett Zamir (http://brett-zamir.me)
  // example 1: nl2br('Kevin\nvan\nZonneveld')
  // returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
  // example 2: nl2br("\nOne\nTwo\n\nThree\n", false)
  // returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
  // example 3: nl2br("\nOne\nTwo\n\nThree\n", true)
  // returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
  // example 4: nl2br(null)
  // returns 4: ''

  // Some latest browsers when str is null return and unexpected null value
  if (typeof str === 'undefined' || str === null) {
    return ''
  }

  // Adjust comment to avoid issue on locutus.io display
  var breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br ' + '/>' : '<br>'

  return (str + '')
    .replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1')
}

export const testLocalstorage = () => {
  var mod = 'modernizr'
  try {
    localStorage.setItem(mod, mod)
    localStorage.removeItem(mod)
    return true
  } catch (e) {
    return false
  }
}

export function clientWidth() {
  return window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
}

export const isMobile = () => {
  let check
  // eslint-disable-next-line
  (a => {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\/-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\/-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\/-(n|u)|c55\/|capi|ccwa|cdm\/-|cell|chtm|cldc|cmd\/-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\/-s|devi|dica|dmob|do(c|p)o|ds(12|\/-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\/-|_)|g1 u|g560|gene|gf\/-5|g\/-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\/-(m|p|t)|hei\/-|hi(pt|ta)|hp( i|ip)|hs\/-c|ht(c(\/-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\/-(20|go|ma)|i230|iac( |\/-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\/-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\/-[a-w])|libw|lynx|m1\/-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\/-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\/-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\/-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\/-([1-8]|c))|phil|pire|pl(ay|uc)|pn\/-2|po(ck|rt|se)|prox|psio|pt\/-g|qa\/-a|qc(07|12|21|32|60|\/-[2-7]|i\/-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\/-|oo|p\/-)|sdk\/|se(c(\/-|0|1)|47|mc|nd|ri)|sgh\/-|shar|sie(\/-|m)|sk\/-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\/-|v\/-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\/-|tdg\/-|tel(i|m)|tim\/-|t\/-mo|to(pl|sh)|ts(70|m\/-|m3|m5)|tx\/-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\/-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\/-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\/-|your|zeto|zte\/-/i.test(a.substr(0, 4)))
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)

  return check || false
}

export const urlName = text => {
  text = text.toLowerCase()
  text = text.replace(/å|ä|ã|â|á|à/gi, 'a')
  text = text.replace(/ö|õ|ô|ó|ò|ø/gi, 'o')
  text = text.replace(/ü|û|ú|ù/gi, 'u')
  text = text.replace(/é|è|ê|ë/gi, 'e')
  text = text.replace(/í|ì|ï|î/gi, 'u')
  text = text.replace('ñ', 'n')
  text = text.replace('ÿ', 'y')
  text = text.replace('ß', 'ss')
  text = text.replace('æ', 'ae')
  text = text.replace(/\s/g, '-')
  text = text.replace(/[-]{2,}/g)
  //text = text.replace('/', '-')
  text = text.replace(/\//g, '-')

  return text
}

export const formatDeliverytime = (dateTime, globalDateTime) => {
  moment.locale('sv')
  if (!dateTime && globalDateTime) {
    return moment(globalDateTime).format('MMMM')
  }

  const estimatedDate = new Date(dateTime)
  const dateAway = new Date().getTime() + (30 * 24 * 60 * 60 * 1000)

  if (estimatedDate > dateAway)
    return moment(estimatedDate).format('MMMM')
  else
    return 'vecka ' + moment(estimatedDate).isoWeek()
}

export const getDate = (dateTime) => {
  moment.locale('sv')
  if (dateTime) {
    return moment(dateTime).format('YYYY-MM-DD')
  }
}